exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*remove ng-host*/\n:host {\n  border:none !important;\n}\n\n/*card in middle on page */\n.col-centered{\n\tfloat: none;\n\tmargin: 0 auto;\n}\n\n\n\n.table{\n\tborder-radius: 10px;\n\t/*border:1px solid gray;*/\n}\n\nth{\n\t/*color: #b2bec3!important;*/\n\tfont-weight: bold;\n\tfont-size: 1vw;\n}\n\n#tableTd{\n\tline-height: 10px !important;\n\tfont-size: 0.95vw;\n}\n\n.overflow-table{\n\theight: 400px;\n\toverflow-y: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/meghneel/work/shree_translogic_dashboard/src/app/voucher/voucher.component.css
// module id = ../../../../../src/app/voucher/voucher.component.css
// module chunks = main